import { call, put, select } from 'redux-saga/effects'

import { setActiveDrawableGroupFromID } from '../../../actions/drawable'
import managers from '../../lib/managers'
import { Workspace } from '../../lib/toolBoxes/2D'
import { selectedPaperItem } from '../../slices/2D'
import { selectIsConflictResolutionInProgress } from '../../slices/masterSetPlan'
import { setCutoutItem } from '../../slices/tools'

export function* updateSelectedPaperAndCutoutItemsFromSelectedIDs(
    action: ReturnType<typeof setActiveDrawableGroupFromID>
) {
    let selectedItemId: number | null = action.payload.selectedItemId
    const isConflictResolutionInProgress: boolean = yield select(selectIsConflictResolutionInProgress)

    if (isConflictResolutionInProgress || (action.payload.activeOpeningLocationId && !selectedItemId)) {
        const paperManager = yield call(managers.get2DManager)
        const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

        if (isConflictResolutionInProgress) {
            const modifications: paper.Item[] = yield call(
                workspaceTool.getItemsWithCriteria,
                'data',
                (data) =>
                    (!!data.materialModificationConflict &&
                        data.materialModificationConflict.material_location_id ===
                            action.payload.activeOpeningLocationId) ||
                    (data.createdDuringConflictResolution &&
                        data.opening_location_id === action.payload.activeOpeningLocationId)
            )

            // A removed conflict must not fall back to its hidden base material.
            const conflict = modifications.find((item) => item.visible && item.data.materialModificationConflict)
            const createdMaterial = modifications.find(
                (item) => item.visible && item.data.createdDuringConflictResolution
            )

            selectedItemId = conflict?.id ?? createdMaterial?.id ?? null
        } else {
            const item = yield call(workspaceTool.getItemWithOpeningLocationId, action.payload.activeOpeningLocationId)

            selectedItemId = item?.id ?? null
        }
    }

    yield put(
        selectedPaperItem({
            selectedItem: selectedItemId,
            activeDrawableId: action.payload.activeDrawableId,
            openingGroupId: action.payload.openingGroupId,
            activeOpeningLocationId: action.payload.activeOpeningLocationId,
        })
    )
    yield put(setCutoutItem(selectedItemId))
}
